import { TimePicker, Space, Button, Divider } from "antd";
import { FilterOutlined, ReloadOutlined } from "@ant-design/icons";

const { RangePicker } = TimePicker;

const TimeRangeFilter = ({
  setSelectedKeys,
  selectedKeys,
  confirm,
  clearFilters,
}) => {
  return (
    <div style={{ padding: 12, width: 260 }}>
      <RangePicker
        style={{ width: "100%" }}
        value={selectedKeys}
        onChange={(times) => {
          setSelectedKeys(times || []);
        }}
        format="HH:mm:ss"
        allowClear
      />

      <Divider style={{ margin: "8px 0" }} />

      <Space style={{ display: "flex", justifyContent: "space-between" }}>
        <Button
          icon={<ReloadOutlined />}
          size="small"
          onClick={() => {
            clearFilters();
            confirm();
          }}
        >
          Reset
        </Button>

        <Button
          type="primary"
          icon={<FilterOutlined />}
          size="small"
          onClick={() => confirm()}
        >
          Apply
        </Button>
      </Space>
    </div>
  );
};

export default TimeRangeFilter;
